import algoliasearch from 'algoliasearch/lite';

export const getAlgoliaClient = (algoliaKey) => {
    return algoliasearch(process.env.GATSBY_ALGOLIA_APPID, algoliaKey);
}

export const getAlgoliaIndex = (indexName, algoliaKey) => {
    return getAlgoliaClient(algoliaKey).initIndex(indexName);
}
